if (document.querySelector('.js-hover-menu')) {
document.querySelectorAll('.mega-menu-4__tab-trigger').forEach(trigger => {
  trigger.addEventListener('mouseenter', () => {
    const triggerName = trigger.getAttribute('xo-name');
    
    document.querySelectorAll('.mega-menu-4__tab-trigger').forEach(t => {
      t.removeAttribute('xo-active');
    });

    document.querySelectorAll('xo-tabs-content xo-tabs-pane').forEach(pane => {
      pane.removeAttribute('xo-active');
    });
    const matchedPane = document.querySelector(`xo-tabs-content xo-tabs-pane[xo-name="${triggerName}"]`);
    if (matchedPane) {
      matchedPane.setAttribute('xo-active', '');
    }
    trigger.setAttribute('xo-active', '');
  });
});
}